/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ScheduleTimeline_DisplayFragment = { __typename: 'Display', id: string, timeZone?: { __typename: 'TimeZoneState', reported: string, desired?: string | null } | null, schedule?: { __typename: 'DisplaySchedule', schedule?: { __typename: 'Schedule', id: string, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', start: string, end: string, day: Types.Day, type: Types.TimeBlockType, priority: number, category: Types.TimeBlockCategory, data: { __typename: 'ScheduleTimeBlockData', id?: string | null, title?: string | null, mediaType?: string | null, applicationId?: string | null, source?: string | null, url?: string | null, value?: number | null } }> } | null, slotWarnings: Array<{ __typename: 'ScheduleSlotWarning', slotIndex: number, warning: Types.ScheduleSlotWarningSeverity }> } | null };

export const ScheduleTimeline_DisplayFragmentDoc = gql`
    fragment ScheduleTimeline_display on Display {
  id
  timeZone {
    reported
    desired
  }
  schedule {
    schedule {
      id
      timeBlocks {
        start
        end
        day
        type
        priority
        category
        data {
          id
          title
          mediaType
          applicationId
          source
          url
          value
        }
      }
    }
    slotWarnings {
      slotIndex
      warning
    }
  }
}
    `;